import styled from '@emotion/styled';

export const ScoreBoardWrapper = styled('div', { label: 'ScoreBoardWrapper' })`
    text-align: center;
`;
